import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthTokenService } from '@hw/hwfe/app/auth/services/auth-token.service';
import { io, Socket } from 'socket.io-client';

@Injectable({ providedIn: 'root' })
export abstract class SocketService {
  private authTokenService = inject(AuthTokenService);
  protected destroyRef = inject(DestroyRef);

  public socket(namespace: string, destroyRef: DestroyRef, payload?: any): Socket {
    const socket = io(`${window.location.origin}/${namespace}`, {
      auth: (cb) => cb({ token: `Bearer ${this.authTokenService.get()}`, ...(payload ?? {}) }),
      autoConnect: true,
    });

    socket.on('connect_error', (err) => {
      console.error(`Connection error on namespace /${namespace}:`, err.message);
    });

    destroyRef.onDestroy(() => {
      socket.disconnect();
    });

    return socket;
  }
}
